import { IdName } from '../../../shared/models/idName';

export class SmsProviders {
    providers: IdName[];
    selected: IdName;
}

export class MobileUserSettings {
    phoneNumber?: string;
    email?: string;
    imageUrl: string;
    smsProviders: SmsProviders;

    constructor(obj: MobileUserSettings | any) {
        Object.assign(this, obj);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/shared/models/user-settings.model.ts